import React, { useState, useEffect, useMemo } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "../../components/MDBox";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import MDTypography from "../../components/MDTypography";
import Card from "@mui/material/Card";
import MDInput from "../../components/MDInput";
import UBKDate from "../../components/UBKDate";
import UBKfile from "../../components/UBKfile";
import { ConfigFile } from "../../services/ConfigFile";
import dayjs from "dayjs";
import toast, { Toaster } from "react-hot-toast";
import useSWR, { mutate as globalMutate } from "swr";
import { Button } from "antd";
import { Table, Pagination } from "antd";
import IconButton from "@mui/material/IconButton";
import { Drawer } from "@mui/material";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import useSWRMutation from "swr/mutation";
import {
  getNewData,
  addData,
  deleteData,
  updateData,
  addDataTigget,
  getadmindataUrl,
} from "../../Api/api";

import { Input } from "antd";
import Modal from "@mui/material/Modal";
import { addOptions, deleteTodoOptions } from "../../Api/apiOption";
//import EditSchool from "./EditSchool";
import MDButton from "../../components/MDButton";
import UBKRadio from "../../components/UBKRadio";
import PrintIcon from "@mui/icons-material/Print";
import { useNavigate } from "react-router-dom";

import { AmountFormat, convertNumberToWords, dateCalculation } from "../../services/TextChangeGlobal";

import { useRazorpay, RazorpayOrderOptions } from "react-razorpay";

// ==========MAIN FUNCTION ======================

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,

  bgcolor: "background.paper",
  //   border: "2px solid #000",
  borderRadius: 2,
  boxShadow: 24,
  //p: 4,
};

function Billing() {

  const { TextArea } = Input;

   let jsonString = JSON.parse(localStorage.getItem("userdata"));
   const { id ,admin_type} = jsonString;


   console.log("branch_id_____",jsonString)



const { error:RzError, isLoading:Rzloading, Razorpay } = useRazorpay();


  const adminid = id;


  const navigate = useNavigate();
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 100,
    },
  });




  const {
    isLoading,
    error,
    data: newData,
    mutate,
  } = useSWR(
    `/superAdmin/getAgentPaymentsPerSchool?id=${adminid}&page=${tableParams.pagination.current}&per_page=${tableParams.pagination.pageSize}`,
    getNewData
  );

  console.log("mainPageData",newData);
  
 


  const columns = [
    {
      title: "Invoice No",
      dataIndex: "receipt_no",
      key: "receipt_no",
    },
     
     {
      title: "Date",
      key: "receipt_date",
      render: (item, record, index) => {
        return (
          <>

            <div style={{ fontSize: "11px" }}>
              <div
                style={{ marginRight: "5px", fontSize: "11px" }}
                className="label label-success"
              >
                {record?.receipt_date}
              </div>
            </div>

          </>
        );
      },
     
    },
    {
      title: "Branch Name",
      dataIndex: "branch_name",
      key: "branch_name",
    },
 
    // {
    //   title: "Note",
    //   dataIndex: "note",
    //   key: "note",
    // },
    // {
    //   title: "Total Student",
    //   dataIndex: "total_student",
    //   key: "total_student",
    // },
     {
         title: "Per Student Cost",
         dataIndex: "per_student_cost",
         align: "per_student_cost",
         render: (item, record, index) => {
           return (
             <div style={{ fontSize: "11px" }}>
               <> {AmountFormat(item)} </>
             </div>
           );
         },
       },
       {
         title: "Agent Commission / Month %",
         dataIndex: "admin_commission",
         align: "admin_commission",
         render: (item, record, index) => {
           return (
             <div style={{ fontSize: "11px" }}>
               <> {item} </>
             </div>
           );
         },
       },
       {
         title: " Invoice Amount",
         dataIndex: "payment_amount",
         align: "payment_amount",
         render: (item, record, index) => {
           return (
             <div style={{ fontSize: "11px" }}>
               <> {AmountFormat(item)} </>
             </div>
           );
         },
       },
       {
         title: "Commission",
         dataIndex: "agent_commission",
         align: "agent_commission",
         render: (item, record, index) => {
           return (
             <div style={{ fontSize: "11px" }}>
               <> {AmountFormat(item)} </>
             </div>
           );
         },
       },
  
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
     
  ];








const loadRazorpay = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };


const PaymentGateway= async ()=>{
  
     const res = await loadRazorpay("https://checkout.razorpay.com/v1/checkout.js");

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    // Ideally, create this order on your backend and fetch the `order_id`
   // const data = await fetch("http://localhost:5000/razorpay", { method: "POST" })
    //  .then((t) => t.json());

  
    const options = {
      key: "rzp_test_RbDBmf9YGnyNHx", // 🔹 Use your test key from Razorpay Dashboard
      amount: 500 * 100, // Amount in paise = ₹500
      currency: "INR",
      name: "Frontend Demo Store",
      description: "Test Payment (Frontend Mock)",
      image: "https://upload.wikimedia.org/wikipedia/commons/7/72/Razorpay_logo.svg",
      handler: function (response) {
        alert(`✅ Payment Successful!\nPayment ID: ${response.razorpay_payment_id}`);
      },
      prefill: {
        name: "John Doe",
        email: "john@example.com",
        contact: "9876543210",
      },
      notes: {
        address: "Razorpay Frontend Mock Demo",
      },
      theme: {
        color: "#3399cc",
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  };

return (
  <DashboardLayout>
    <DashboardNavbar />
   
    <Toaster toastOptions={{ position: "top-center" }} />
    <MDBox pt={8} pb={1}>
     
       <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={1}
                px={1}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Invoice List
                </MDTypography>
              </MDBox>

              {!isLoading ? (
                <MDBox pt={1} style={{ textAlign: "center" }}>
                  <>{newData?.admin?<> 
                   <>
                   {newData?.admin[0]?.name} {newData?.admin[0]?.company_name}
                 </>
                 <> {newData?.admin[0]?.start_date}</>
                 </>
                :<></>}</>
                 
                </MDBox>
              ) : (
                <></>
              )}
              <MDBox pt={1}>
                {!isLoading ? (
                  <>
                   

                    <Table
                      style={{ margin: "50px" }}
                      columns={columns}
                      // expandable={{
                      //   expandedRowRender,
                      //   defaultExpandedRowKeys: ["0"],
                      // }}
                    //   rowSelection={rowSelection}
                      dataSource={newData?.data}
                       rowKey="id"
                     // rowKey={(record) => record.branch_id}
                    />
                  </>
                ) : (
                  <>Loading...</>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
    </MDBox>
  </DashboardLayout>
);
}


export default Billing;
